import { render, staticRenderFns } from "./standard-flag.vue?vue&type=template&id=2c57d984&scoped=true"
import script from "./standard-flag.vue?vue&type=script&lang=ts"
export * from "./standard-flag.vue?vue&type=script&lang=ts"
import style0 from "./standard-flag.vue?vue&type=style&index=0&id=2c57d984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57d984",
  null
  
)

export default component.exports